import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MeterSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MeterSVG;
